import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.regexp.split";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import NopeReference from './NopeReference';
export function resolveNopeRefsFromKeys(options, context) {
  var resolvedOptions = options.map(function (option) {
    if (context && option !== undefined && option !== null) {
      return context[option];
    }

    return option;
  });
  return resolvedOptions;
}
export function every(arr, predicate) {
  return arr.filter(function (value) {
    return !predicate(value);
  }).length === 0;
}
export function resolveNopeRef(option, context) {
  if (option instanceof NopeReference && context) {
    return context[option.key];
  }

  return option;
}
export function deepEquals(a, b) {
  if (typeof a == 'object' && a != null && typeof b == 'object' && b != null) {
    if (a === b) {
      return true;
    }

    var aCount = 0;
    var bCount = 0; // eslint-disable-next-line @typescript-eslint/no-unused-vars

    for (var _ in a) {
      aCount++;
    } // eslint-disable-next-line @typescript-eslint/no-unused-vars


    for (var _2 in b) {
      bCount++;
    }

    if (aCount - bCount !== 0) {
      return false;
    }

    for (var key in a) {
      if (!(key in b) || !deepEquals(a[key], b[key])) {
        return false;
      }
    }

    for (var _key in b) {
      if (!(_key in a) || !deepEquals(b[_key], a[_key])) {
        return false;
      }
    }

    return true;
  }

  return a === b;
}
export function pathToArray(path) {
  return path.split(/[,[\].]/g).filter(Boolean);
}
export function getFromPath(path, entry) {
  var dropLast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!path) {
    return undefined;
  }

  var pathArray = pathToArray(path);
  pathArray = dropLast ? pathArray.slice(0, -1) : pathArray;
  var value = entry;

  var _iterator = _createForOfIteratorHelper(pathArray),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      value = value[key];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return value;
}